import { compose } from 'redux'
import { withHandlers, withState } from 'recompose'
import { rest } from 'services'

const getAddresses = ({ data: { Results: results }}) =>
  results.map(({ Address: { AddressLine1: address1, City: city, State: state, PostalCode: zipCode }}) => ({
    address1,
    city,
    state,
    zipCode
  }))

const withAddresses = withState('addresses', 'setAddresses', [])

const withFetchAddresses = withHandlers({
  fetchAddresses: ({ setAddresses }) => query =>
    rest.api
      .getExpressAddress(query)
      .then(result => setAddresses(getAddresses(result)))
})

const withResetAddresses = withHandlers({
  resetAddresses: ({ setAddresses }) => () => setAddresses([])
})

export default compose(
  withAddresses,
  withFetchAddresses,
  withResetAddresses
)
